import React from 'react';
import FeedPresenterSpotlight from '../main-video/feed-presenter-spotlight';
import FeedScreenShareSpotlight from '../main-video/feed-screenshare-spotlight';
import Socket from '../../connection/socket';
import FeedMediaSpotlight from '../main-video/feed-media-spotlight';
import FeedSipCallSpotlight from '../main-video/feed-sip-call-spotlight';
import FeedSrtStreamSpotlight from '../main-video/srt-stream/feed-srt-stream-spotlight';
import FeedOnsiteLocationSpotlight from '../main-video/onsite-location/feed-onsite-location-spotlight';
import feedIngressStreamSpotlight from '../main-video/ingress-stream/feed-ingress-stream-spotlight';

export enum FeedType {
	presenter = 'presenter',
	media = 'media',
	audio = 'audio',
	screenshare = 'screenshare',
	containermedia = 'containermedia',
	sipCall = 'sipCall',
	srtStream = 'srtStream',
	ingressStream = 'ingressStream',
	onsiteLocation = 'onsiteLocation',
}

const componentMap: { [key: string]: any } = {
	[FeedType.presenter]: FeedPresenterSpotlight,
	[FeedType.media]: FeedMediaSpotlight, // MediaVideoSpotlight, //,
	[FeedType.audio]: FeedMediaSpotlight,
	[FeedType.screenshare]: FeedScreenShareSpotlight,
	[FeedType.containermedia]: FeedMediaSpotlight,
	[FeedType.sipCall]: FeedSipCallSpotlight,
	[FeedType.srtStream]: FeedSrtStreamSpotlight,
	[FeedType.ingressStream]: feedIngressStreamSpotlight,
	[FeedType.onsiteLocation]: FeedOnsiteLocationSpotlight,
};

export const propMap = {
	presenter: (
		key: number | string,
		position: number,
	) => ({
		mediaId: key,
		feedPosition: position,
	}),
	media: (
		key: number | string,
		position: number,
		isAudioOnly:boolean,
		isPreloading:boolean,
		iterateLoadedMediaCount?: Function,
		socket?: Socket | null,
	) => ({
		mediaId: key,
		feedPosition: position,
		className: 'media-video',
		iterateLoadedMediaCount,
		socket,
		isPreloading: false,
		doEchoCancel: true,
		audioOnly: isAudioOnly,
		isEditingFeed: false,
		isForMainVideoEditingComponent: false,
	}),
	audio: (
		key: number | string,
		position: number,
		isAudioOnly:boolean,
		isPreloading:boolean,
		iterateLoadedMediaCount?: Function,
		socket?: Socket | null,
	) => ({
		mediaId: key,
		feedPosition: position,
		className: 'media-video',
		iterateLoadedMediaCount,
		socket,
		isPreloading: false,
		doEchoCancel: true,
		audioOnly: isAudioOnly,
		isEditingFeed: false,
		isForMainVideoEditingComponent: false,
	}),
	screenshare: (
		key: number | string,
		position: number,
	) => ({
		mediaId: key,
		feedPosition: position,
	}),
	sipCall: (
		key: number | string,
		position: number,
	) => ({
		mediaId: key,
		feedPosition: position,
	}),
	srtStream: (
		key: number | string,
		position: number,
	) => ({
		mediaId: key,
		feedPosition: position,
	}),
	ingressStream: (
		key: number | string,
		position: number,
	) => ({
		mediaId: key,
		feedPosition: position,
	}),
	onsiteLocation: (
		key: number | string,
		position: number,
	) => ({
		mediaId: key,
		feedPosition: position,
	}),
};

interface DynamicComponentProps {
	type: FeedType;
	props: { [key: string]: any } | null;
	children: JSX.Element;
}

export default function DynamicComponent({ type, ...props }: DynamicComponentProps) {
	const Component = componentMap[type];

	if (!Component) return null;
	return (
        <Component {...props.props} >
            {props.children}
        </Component>
	);
}
